// import First from "../slider/assets/First.jpg";
import A from "../slider2/assets/A.jpg"
import B from "../slider2/assets/B.jpg"
import C from "../slider2/assets/C.gif"
import D from "../slider2/assets/D.gif"
import E from "../slider2/assets/E.jpg"
import F from "../slider2/assets/F.jpg"

export default 
 [
  {
    title: "First Slide",
    description: "This is the first slider Image of our carousel",
    urls: A,
  },
  
  {
    title: "Second Slide",
    description: "This is the second slider Image of our carousel",
    urls: B,
  },
  {
    title: "Third Slide",
    description: "This is the Third slider Image of our carousel",
    urls: C,
  },
  {
    title: "Fourth Slide",
    description: "This is the Fourth slider Image of our carousel",
    urls: D,
  },
  {
    title: "Fifth Slide",
    description: "This is the Fifth slider Image of our carousel",
    urls: E,
  },
  {
    title: "Sixth Slide",
    description: "This is the Sixth slider Image of our carousel",
    urls: F,
  },
  
]
